import React from 'react';
import { Text } from '@spotify-internal/encore-web';
import styled from 'styled-components';

import Metatags from 'components/Metatags/Metatags';
import WarningBanner from 'components/WarningBanner/WarningBanner';
import { useTranslation } from 'providers/translations/TranslationProvider';
import PageContainer from 'components/PageContainer';
import { useServerSideConstants } from 'providers/ServerSideConstantsProvider';
import { SharedPageData } from 'utils/shared-page-data';

import EnglishOnlySupportBanner from './EnglishOnlySupportBanner';
import EmailContainer from './EmailContainer';
import ContactContent from './ContactContent';

const StyledType = styled(Text)`
  margin-bottom: 20px;
`;

export interface ContactPageProps {
  sharedPageData?: SharedPageData;
}

const ContactPage = ({ sharedPageData }: ContactPageProps) => {
  const { t } = useTranslation();
  const {
    verticalConfig: { features },
  } = useServerSideConstants();
  const { banner } = sharedPageData || {};

  return (
    <>
      <Metatags desc={t('contact_title')} noIndex />
      <WarningBanner banner={banner} />

      <PageContainer>
        <StyledType forwardedAs="p" variant="bodyMedium" semanticColor="textSubdued" aria-hidden="true">
          {t('contact_support_headline')}
        </StyledType>
        <EnglishOnlySupportBanner />
        {features.onlyEmailSupport ? <EmailContainer /> : <ContactContent />}
      </PageContainer>
    </>
  );
};

export default ContactPage;
